/*
 * MarketPage Messages
 *
 * This contains all the text for the MarketPage container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.LandingPage.KeepInTouch';

export default defineMessages({
  yourName: {
    id: `${scope}.yourName`,
    defaultMessage: 'Tên của bạn',
  },
  phone: {
    id: `${scope}.phone`,
    defaultMessage: 'Số điện thoại',
  },
  whoYouAre: {
    id: `${scope}.whoYouAre`,
    defaultMessage: 'Cho chúng tôi biết thêm về bạn',
  },
  validateWhoYouAre: {
    id: `${scope}.validateWhoYouAre`,
    defaultMessage: 'Vui lòng cho chúng tôi biết thêm về bạn',
  },
  placeAMessage: {
    id: `${scope}.placeAMessage`,
    defaultMessage: 'Hãy để lại lời nhắn',
  },
  subTitle: {
    id: `${scope}.subTitle`,
    defaultMessage: 'Hãy để bộ phận kinh doanh của chúng tôi hỗ trợ bạn',
  },
  formHeader: {
    id: `${scope}.formHeader`,
    defaultMessage: 'Liên hệ chúng tôi',
  },
  firstFormSubHeader: {
    id: `${scope}.firstFormSubHeader`,
    defaultMessage: 'Có yêu cầu hoặc ý kiến phản hồi với chúng tôi?',
  },
  secondFormSubHeader: {
    id: `${scope}.secondFormSubHeader`,
    defaultMessage: 'Hãy điền vào biểu mẫu dưới đây để liên hệ chúng tôi',
  },
  contactToSale: {
    id: `${scope}.contactToSale`,
    defaultMessage: 'Tạo tài khoản doanh nghiệp',
  },
  submitForm: {
    id: `${scope}.submitForm`,
    defaultMessage: 'Gửi',
  },
  contactUsSuccess: {
    id: `${scope}.contactUsSuccess`,
    defaultMessage: 'Đã liên hệ thành công',
  },
  whoAreYou: {
    id: `${scope}.whoAreYou`,
    defaultMessage: 'Bạn là ai',
  },
  yourMessage: {
    id: `${scope}.yourMessage`,
    defaultMessage: 'Nội dung bạn muốn gửi đến Kamereo',
  },
});
